// source: advai_event/atome_id/page.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf')
var goog = jspb
var global = Function('return this')()

goog.exportSymbol('proto.advai_event.atome_id.PageName', null, global)
/**
 * @enum {number}
 */
proto.advai_event.atome_id.PageName = {
  PAGENULL: 0,
  LOGIN: 1,
  FBLOGIN: 2,
  SMSOTP: 3,
  HOME: 4,
  BILL: 5,
  BILLHISTORY: 6,
  BILLSTATEMENTS: 7,
  PAYMENTMETHOD: 8,
  HOWTOPAY: 9,
  SETTINGS: 10,
  KTP: 11,
  KTPHOLDING: 12,
  MODULEKTP: 13,
  MODULEKTPHOLDING: 14,
  FIRST: 15,
  SECOND: 16,
  APPLYSUPPLEMENT: 17,
  BANKINFO: 18,
  PREBORROW: 19,
  MODULEBASICINFO: 20,
  MODULECONTACTINFO: 21,
  MODULEWORKINFO: 22,
  MODULEBANKINFO: 23,
  MODULEAPPLYSUPPLEMENT: 24,
  MODULEPREBORROW: 25,
  MODULEAPPLY: 26,
  APPLYLOAN: 27,
  ADDLOANBANKCARD: 28,
  SUPPLEMENT: 29,
  SUPPLEMENTUPLOAD: 30,
  COLLECTDATAWINDOW: 31,
  RATEATOMEWINDOW: 32,
  INSTALLMENTDETAILS: 33,
  ME: 34,
  APPROVALWINDOW: 35,
  RESUBMITKTP: 36,
  RESUBMITKTPHOLDING: 37,
  RESUBMITBANKINFO: 38,
  APPLY: 39,
  REFERFRIENDS: 40,
  KTPDETAILS: 41,
  TERMSERVICE: 42,
  PRIVACYPOLICY: 43,
  ABOUTUS: 44,
  NOTIFICATIONS: 45,
  NOTIFICATIONDETAILS: 46,
  MYLOANS: 47,
  LOANDETAILS: 48,
  HELPCENTER: 49,
  HELPCENTERPAYMENTINSTRUCTIONS: 50,
  REFERFRIENDSB: 51,
  REFERFRIENDSHISTORY: 52,
  REFERFRIENDSA: 53,
  PREBORROWB: 54,
  MODULEPREBORROWB: 55,
  BANKLIST: 56,
  KTPGUIDE: 57,
  MODULEKTPGUIDE: 58,
  KTPHOLDINGGUIDE: 59,
  MODULEKTPHOLDINGGUIDE: 60,
  KTPCAMERA: 61,
  MODULEKTPCAMERA: 62,
  KTPHOLDINGCAMERA: 63,
  KTPRESULT: 65,
  MODULEKTPRESULT: 66,
  KTPHOLDINGRESULT: 67,
  MODULEKTPHOLDINGRESULT: 68,
  PERSONALINFO: 69,
  RESIDENTIALINFO: 70,
  EMERGENCYCONTACT: 71,
  WORKINFO: 72,
  BANKINFOB: 73,
  APPLYSUPPLEMENTB: 74,
  PREBORROWC: 75,
  FORMENTRY: 76,
  LOANAGREEMENT: 77,
  LINKACCOUNT: 78,
  LINKACCOUNTDETAIL: 79,
  APPLYNKPLOAN: 80,
  REWARDSUPPLEMENT: 81,
  MYVOUCHERS: 82,
  APPLYLOANNKPPREBORROW: 83,
  APPLYLOANOKPPREBORROW: 84,
  START: 85,
  LOGINPHONE: 86,
  LOGINOTP: 87,
  PRESCREENDOCUPLOAD: 88,
  BANKSTATEMENTS: 89,
  CREDITCARDSTATEMENTS: 90,
  CAMERA: 91,
  LAUNCH: 92,
  QUESTIONDETAILS: 93,
  TOPIC: 94,
  STATEMENTDETAILS: 95,
  BACKGROUNDSERVICE: 96,
  REWARDSDETAIL: 97,
  ACCEPTINVITATION: 98,
  APPLYEXTENSION: 99,
  POSBORROW: 100,
  POSORDERDETAILS: 101,
  POSVERIFYKTP: 102,
  POSLOANHOME: 103,
  POSLOANAGREEMENT: 104,
  COUPONLANDINGPAGE: 105,
  RISK: 106,
  QTTPOINTSPAGE: 107,
  QTTSHARELANDINGPAGE: 108,
  QTTNEWSLIST: 109,
  QTTARTICLEDETAIL: 110,
  QTTVIDEOLIST: 111,
  SMSCOUPONLANDINGPAGE: 112,
  SMSCOUPONLANDINGPAGEB: 113,
  QTTLOTTERY: 114,
  MANDATORYBRANCHD: 115,
  BACKGROUND: 1000000,
  FACEDETECTION: 116,
  HRCONTACTINFO: 117,
  LOTTERYACTIVITY: 118,
  APPLYLOANPURPOSE: 119,
  MYACCOUNT: 120,
  MYPROFILE: 121,
  MYLINKACCOUNT: 122,
  CHANGEUSERNAME: 123,
  MYPERSONALINFO: 124,
  MYCONTACTINFO: 125,
  MYRESIDENTIALINFO: 126,
  MYWORKINFO: 127,
  LOGINFAQ: 128,
  QUESTIONDETAIL: 129,
  CHANGEPHONEGUIDE: 130,
  CHANGEPHONEREASON: 131,
  CHANGEPHONENUM: 132,
  CHANGEPHONEOTP: 133,
  VERIFYPHONENUMBER: 134,
  POINTSCENTER: 135,
  DAILYTASKS: 136,
  POINTSDETAIL: 137,
  PRODUCTDETAILS: 138,
  PRODUCTORDER: 139,
  EXCHANGERESULT: 140,
  NOSMSCODE: 142,
  NOPHONENUMBER: 143,
  APPLYLOANOTP: 144,
  CREDITSCORE: 145,
  SCORERECORDS: 146,
  REFERFRIENDSTASK: 147,
  KPWEBSITEHOME: 148,
  KPWEBSITEPRODUCT: 149,
  KPWEBSITEFAQ: 150,
  KPWEBSITEABOUT: 151,
  KPWEBSITEEDUCATION: 152,
  KPWEBSITECOMPETITION: 153,
  KPWEBSITEPINTARSCORE: 154,
  KPPRIVACYPOLICY: 155,
  KPWEBSITESEARCH: 156,
  KPSITEMAP: 157,
  KPTERMSOFSERVICE: 158,
  KPEDUCATEGORY: 159,
  KPWEBSITEEDUTAG: 160,
  KPWEBSITEBLOGDETAIL: 161,
  LINEARAPPLY: 162,
  LINEARPERSONALINFO: 163,
  LINEARWORKINFO: 164,
  LINEARCONTACTINFO: 165,
  LINEARBANKINFO: 166,
  LINEARSUPPLEMENT: 167,
  IDENTITYINFO: 168,
  VIDEOKYC: 169,
  WEBVIEW: 170,
  MYSCORE: 171,
  ADDITIONALUPLOAD: 172,
  PAYFROMHOME: 173,
  RESUBMITSUPPLEMENT: 174,
  TCAGREEMENT: 175,
  VERIFYNIK: 176,
  REPAYMENTRECORD: 177,
  ORDERAGREEMENT: 178,
  AGREEMENT: 179,
  REFERFRIENDSPAGE: 180,
  REFERFRIENDSPOPUP: 181,
  REFERFRIENDSDETAILS: 182,
  HELPCENTERROUTE: 183,
  LOTTERYRECORDS: 184,
  CREDITSCORERULE: 185,
  KPWEBSITEENTRY: 186,
  TRIPARTITEENTRY: 187,
  COUPONMODAL: 188,
  CORONAVIRTUAL: 189,
  REPATMENT: 190,
  COUPONPOPUP: 191,
  ENTRY: 192,
  RESUBMIT: 193,
  BANKDOWNLOADLATESTAPP: 194,
  BANKFACEDETECTIONSTART: 195,
  RESUBMITFACEDETECTIONSTART: 196,
  RESUBMITFACEDETECTIONNEXT: 197,
  BANKFACEDETECTIONNEXT: 198,
  RESUBMITDOWNLOADLATESTAPP: 199,
  CAPSULETOYS: 200,
  ADDRESSHOME: 201,
  CURRENTADDRESS: 202,
  ADDRESSDETAIL: 203,
  PINTARSHOP: 204,
  EXHANGERESULT: 205,
  REDEMPTION: 206,
  REDEMPTIONPRODUCTDETAILS: 207,
  PLACEORDER: 208,
  MYCOINS: 209,
  PLAYVEDIOS: 210,
  POSTLIST: 211,
  POSTDETAIL: 212,
  VIDEOLIST: 213,
  DOWNLOADAPP: 214,
  COINGOODSLIST: 215,
  COINSRECORD: 216,
  COINPRODUCTDETAILS: 217,
  COINPRODUCTORDER: 218,
  COINEXCHANGERESULT: 219,
  MYAPPLICATIONS: 220,
  SEIZETREASURE: 221,
  LOANPREVIEW: 222,
  LOANAGREEMENTLIST: 223,
  LOANCOMPLETED: 224,
  VERIFYOTP: 225,
  CHECKIN: 226,
  LOANFAQ: 227,
  LOANAGREEMENTNOSIGNLIST: 228,
  MODULEPERSONALINFO: 229,
  LINEARKTP: 230,
  LINEARKTPHOLDING: 231,
  MANDATORYBRANCH: 232,
  HASLIMITPDLPREBORROW: 233,
  STARTPAGE: 234,
  WELCOMEPAGE: 235,
  LOGINOTPCHECKPAGE: 236,
  LOGINPASSWORDCHECKPAGE: 237,
  FIRSTTIMELOGINPASSWORDCHECKPAGE: 238,
  CREATEPASSWORDPAGE: 239,
  LOGINWITHFACEIDINFOPAGE: 240,
  LOGINWITHFACEIDDONEPAGE: 241,
  RESETPASSWORDPAGE: 242,
  SETPASSWORDPAGE: 243,
  CONFIRMPASSWORDPAGE: 244,
  VERIFYCURRENTPASSWORDPAGE: 245,
  CREATENEWPASSWORDPAGE: 246,
  SECURITYPAGE: 247,
  MYACCOUNTPAGE: 248,
  LOGINWITHFACEIDCHECKPAGE: 249,
  MESSAGENOTIFICATIONSSETTINGPAGE: 250,
  NOTIFICATIONCENTERPAGE: 251,
  WORDPRESSNOTIFICATIONPAGE: 252,
  DEFAULTNOTIFICATIONDETAILPAGE: 253,
  CHECKINPAGE: 254,
  PINTARSHOPPAGE: 255,
  EDUCATIONPAGE: 256,
  CAREERPAGE: 257,
  ABOUTUSPAGE: 258,
  FAQPAGE: 259,
  HOMEPAGE: 260,
  PINTARSCOREPAGE: 261,
  PRODUCTPAGE: 262,
  PINTARSHOPSHAREDPAGE: 263,
  CHALLENGEPROGRAM: 264,
  WELCOMEBACKPAGE: 265,
  BOOSTYOURPINTARSCORECAMPAIGNPAGE: 266,
  MOBILEPREPAIDPRODUCTPAGE: 268,
  MOBILEPOSTPAIDBRANDPAGE: 269,
  MOBILEPOSTPAIDPRODUCTPAGE: 270,
  VOUCHERGAMEBRANDPAGE: 271,
  VOUCHERGAMEPRODUCTPAGE: 272,
  CEOLETTERPAGE: 273,
  WELCOMEOFFERPAGE: 274,
  TRANSACTIONINPROGESSPAGE: 275,
  GIVEBACKSEASONPAGE: 276,
  CLICKABLEAREALANDINGPAGE: 277,
  COINSPRODUCTDETAILSPAGE: 278,
  PLACEORDERPAGE: 279,
  EXCHANGERESULTPAGE: 280,
  MYCOINSDETAILPAGE: 281,
  SHOPVIDEOLANDINGPAGE: 282,
  SHOPVIDEOREDIRECTPAGE: 283,
  REDEMPTIONPAGE: 284,
  PINTARREPORTPAGE: 285,
  KTPAUTHENTICATIONPAGE: 286,
  KTPAUTHENTICATIONFAILEDPAGE: 287,
  EFFORTLESSLOGINPAGE: 288,
  EFFORTLESSBASICINFOPAGE: 289,
  EFFORTLESSKTPHOLDINGPAGE: 290,
  EFFORTLESSCREDITLOADINGPAGE: 291,
  EFFORTLESSCREDITSTATUSPAGE: 292,
  EFFORTLESSHOMEPAGE: 293,
  EFFORTLESSAPPLYLOANPAGE: 294,
  EFFORTLESSKTPPAGE: 295,
  MYSAVINGACCOUNTPAGE: 297,
  JAGOENTRYPAGE: 298,
  CARDACCOUNTDETAILPAGE: 299,
  JAGOLOGINFORMPAGE: 300,
  JAGOHELPLISTPAGE: 301,
  JAGOHELPDETAILPAGE: 302,
  JAGODOWNLOADLATESTAPP: 303,
  INVITEFRIENDLANDINGPAGE: 304,
  INVITEFRIENDREWARDSPAGE: 305,
  REDEEMABLETOKENSPAGE: 306,
  TOKENSREDEEMDETAILPAGE: 307,
  RESUBMITEMAILVERIFICATIONPAGE: 308,
}

goog.object.extend(exports, proto.advai_event.atome_id)
